<template>
    <div class="contenedor-registrar-nuevo-oficio-autorizacion-detalle">
        <v-form
        ref="registrarNuevoOficioDetalle"
        >
        <v-card>
            <v-card-title class="secondary--text">
                Registrar nuevo recurso de oficio de autorización
                <v-spacer></v-spacer>
                <v-btn icon @click="cerrar">
                  <v-icon class="secondary--text" large>highlight_off</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <div>
                  <span class="secondary--text font-weight-bold">
                    NÚMERO DE OFICIO
                  </span>
                  </div>
                  <div>
                  <span>
                    {{ oficio.numero }} </span>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <div>
                  <span class="secondary--text font-weight-bold" >
                    TIPO
                  </span>
                  </div>
                  <div>
                  <span v-if="oficio.tipo === 'AUTORIZACIÓN'">
                      {{oficio.tipo}}
                  </span>
                  <span v-if="oficio.tipo === 'CANCELACIÓN'" >
                      {{oficio.tipo}}
                  </span>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <div>
                  <span class="secondary--text font-weight-bold pa-5" >
                    IMPORTE
                  </span>
                  </div>
                  <div>
                    <v-chip class="font-weight-bold pa-5" :color="getColorSumaDetalle">
                    <span>{{ oficio.importe | currency }} </span>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="12" sm="12" md="5" >
                  <obras-solicitudes-picker
                  v-on:input="inputObraSolicitada"
                  :multiSelect="false">
                  </obras-solicitudes-picker>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <custom-text-field
                    v-model.number="detalle.importe"
                    label="Importe*"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    required
                  >
                  </custom-text-field>
                </v-col>
                <v-col>
                  <custom-text-field
                  v-model="detalle.clavePresupuestal"
                  label="Clave Presupuestal*"
                  :rules="[mixReglas.requerido]"
                  required
                  >
                  </custom-text-field>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12">
                  <cortar-textos
                  :texto="obraMeta">
                  </cortar-textos>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <obras-picker
                  v-on:input="inputObra"
                  :multiSelect="false"
                  >
                  </obras-picker>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="12" md="6">
                  <presupuesto-detalle-picker
                  :isDisabled="detalle.idObra === '' || detalle.idObra === null"
                  v-on:inputPresupuestoDetalle="inputPresupuestoDetalle"
                  :idObra="detalle.idObra"
                  :multiSelect="false"
                  >
                  </presupuesto-detalle-picker>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="bkground"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                 <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                @click="mixAgregarOficioDetalle"
                    :disabled="!formularioValido || enviandoFormulario"
                    :loading="enviandoFormulario"
                    tipo="formAceptar"
                    label="Guardar"
                >

                </custom-button>
            </v-card-actions>
        </v-card>
        </v-form>
    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CortarTextos from '@/components/CortarTextos.vue';
import ObrasPicker from '@/components/ObrasPicker.vue';
import ObrasSolicitudesPicker from '@/components/SolicitudObrasPicker.vue';
import PresupuestoDetallePicker from '@/components/PresupuestoDetallePicker.vue';
import MixOficioAutorizacionDetalle from './mixOficioAutorizacionDetalle';

export default {
  name: 'registrarNuevoOficioAutorizacionDetalle',
  props: {
    oficio: {
      type: Object,
      required: true,
    },
    sumaDetalles: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      oficioAutorizacionTotal: 0,
      obraMeta: '',
      claveObra: '',
      detalle: {
        idOficioAutorizacion: this.oficio.id,
        idFuenteFinanciera: '',
        idObra: null,
        idObraSolicitada: null,
        clavePresupuestal: '',
        importe: null,
      },

    };
  },
  mixins: [
    MixOficioAutorizacionDetalle,
  ],
  components: {
    CustomButton,
    CustomTextField,
    ObrasPicker,
    ObrasSolicitudesPicker,
    PresupuestoDetallePicker,
    CortarTextos,
  },
  methods: {

    inputObra(obrasSeleccionadas) {
      if (!Array.isArray(obrasSeleccionadas) && obrasSeleccionadas !== null) {
        this.detalle.idObra = obrasSeleccionadas.id;
      } else {
        this.detalle.idObra = null;
      }
    },
    inputObraSolicitada(obrasSeleccionadas) {
      if (!Array.isArray(obrasSeleccionadas) && obrasSeleccionadas !== null) {
        this.detalle.idObraSolicitada = obrasSeleccionadas.id;
        this.obraMeta = obrasSeleccionadas.meta;
        this.detalle.clavePresupuestal = obrasSeleccionadas.clave;
        this.detalle.importe = obrasSeleccionadas.importe;
        this.detalle.idFuenteFinanciera = '';
      } else {
        this.detalle.idObra = null;
        this.detalle.idObraSolicitada = null;
        this.detalle.clavePresupuestal = '';
        this.obraMeta = '';
        this.detalle.importe = null;
        this.detalle.idFuenteFinanciera = '';
      }
    },
    inputPresupuestoDetalle(presupuestoDetallesSeleccionados) {
      if (!Array.isArray(presupuestoDetallesSeleccionados)
      && presupuestoDetallesSeleccionados !== null) {
        this.detalle.idFuenteFinanciera = presupuestoDetallesSeleccionados.id;
      } else {
        this.detalle.idFuenteFinanciera = '';
      }
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoOficioDetalle.reset();
    },
    sumarImportesOficios() {
      this.oficioAutorizacionTotal = this.$ObjSumar(this.oficio, 'importe');
    },
  },
  computed: {
    formularioValido() {
      /*
      if (this.detalle.idObra === '' || this.detalle.idObra === null) {
        return false;
      } */
      if (this.detalle.importe === null || this.detalle.importe === ''
      || this.detalle.clavePresupuestal === null || this.detalle.clavePresupuestal === '') { return false; }
      return true;
    },
    getColorSumaDetalle() {
      if ((this.sumaDetalles + this.detalle.importe) === 0) { return 'bkground'; }
      if ((this.sumaDetalles + this.detalle.importe) === this.oficio.importe) return 'success';
      return 'warning';
    },
  },

};
</script>
